import { NgModule } from '@angular/core'
import { ProgressService } from '@mmx/shared'

@NgModule({
  providers: [
    ProgressService,
  ],
})
export class ProgressModule {}
